/**
 * Posición fixed para paneles anclados a un botón (menús, popovers).
 */
export function getFloatingPanelFixedStyle(anchorRect, options = {}) {
  const {
    width = 260,
    estimatedHeight = 320,
    gap = 8,
    alignRight = true,
    zIndex = 12050
  } = options;

  if (!anchorRect) return null;

  let left = alignRight ? anchorRect.right - width : anchorRect.left;
  left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

  let top = anchorRect.bottom + gap;
  if (top + estimatedHeight > window.innerHeight - 12) {
    top = anchorRect.top - estimatedHeight - gap;
  }
  top = Math.max(12, Math.min(top, window.innerHeight - estimatedHeight - 12));

  return {
    position: 'fixed',
    top: `${Math.round(top)}px`,
    left: `${Math.round(left)}px`,
    width: `${Math.round(width)}px`,
    zIndex
  };
}
